import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import HttpResponse from './httpResponse'
import LoggingService from '@/services/loggingService'

class HttpClient {
  defaultHeaders

  constructor (defaultHeaders = {}) {
    this.defaultHeaders = defaultHeaders || {}
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = process.env.API_URL
  }

  async send (url = '', method = HttpRequestMethods.get, headers = {}, content = {}, isJsonContent = true) {
    let response
    try {
      let requestHeaders = {
        'content-type': isJsonContent ? 'application/json' : 'application/x-www-form-urlencoded; charset=UTF-8'
      }
      requestHeaders = {
        ...requestHeaders,
        ...this.defaultHeaders,
        ...headers
      }

      let fetchResponse = await Vue.axios({
        method: method,
        url: url,
        data: isJsonContent ? JSON.stringify(content) : new FormData(content),
        headers: requestHeaders
      })
      response = await this.getHttpResponse(fetchResponse)
    } catch (err) {
      try {
        response = await this.getHttpResponse(Response.error())
      } catch (err) {
        response = null
      }
    }
    return response
  }

  async getHttpResponse (fetchResponse) {
    let httpResponse = new HttpResponse()

    if (fetchResponse !== null) {
      try {
        httpResponse.isSuccessStatusCode = fetchResponse.status >= 200 && fetchResponse.status < 300
        httpResponse.statusCode = fetchResponse.status
        httpResponse.headers = fetchResponse.headers

        if (httpResponse.isSuccessStatusCode) {
          httpResponse.body = fetchResponse.data
        }
      } catch (err) {
        LoggingService.error(err)
      }
    }
    return httpResponse
  }
}

export const HttpRequestMethods = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete'
}

export default HttpClient
